import React from 'react'

export default function TextInputComponent({ title, value, handleChange, textId }) {

    return (
        <div className="input-field">
            <div className="edit_button_card_subtitle" dir="auto">{title}</div>
            <input dir="auto"
                className="browser-default edit_button_card_input"
                type="text" id={textId}
                style={{ textAlign: "center" }}
                onChange={(e) => handleChange(e)}
                placeholder="" value={value} />
        </div>
    )
}
